<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'plans.back' | translate }}</button>
    </app-page-header>
    <form [formGroup]="form" class="needs-validation" >
      <div class="plans-data">
        <div class="second-headboard">
          <h1>{{ 'plans.title' | translate }}</h1>
          <!-- <img src="../../../assets/icons/4123.png" alt="logo de Billcentrix"> -->
          <div class="linked-icons" >
            <button (click)="goBack()">{{ 'plans.steps.initial' | translate }}</button>
            <button class="active" >{{ 'plans.steps.createPlan' | translate }}</button>
            <button>{{ 'plans.steps.activate' | translate }}</button>

            <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goToAccount()">
            <img src="../../assets/icons/2_portales_off.png" alt="Paso 2: Portal" (click)="goToTemplates()">
            <img src="../../assets/icons/3_personalizar_off.png" alt="Paso 3: Personalizar" (click)="goBack()">
            <img src="../../assets/icons/4_planes_on.png" alt="Paso 4: Planes" > -->
          </div>
        </div>
        <div class="plans-data-text">
          <strong>{{ 'plans.whatOffer' | translate }}</strong>
          <p class="line-spacing">{{ 'plans.description' | translate }}</p>
        </div>
        <div class="preview-text">
          <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
          <p class="text-right">Vista previa</p> -->
        </div>
        <div class="grid">
          <div class="create-first-plan">
            <h1>{{ 'plans.createPlan' | translate }}</h1>
            <div class="second-grid">
              <div class="upper-part">
                <div class="left">
                  <div class="items">
                    <div>
                      <label for="type">Tipo de plan*</label>
                      <i class="material-icons icon-help" matTooltip="Link de Pago: cobro único por enlace. Normal: suscripción con monto fijo del plan. Variable: suscripción con monto definido por cliente.">help_outline</i>
                    </div>
                    <select id="type" [formControl]="form.controls['type']" tabindex="1" required>
                      <option [ngValue]="PlanType.LINK_DE_PAGO">Link de Pago</option>
                      <option [ngValue]="PlanType.NORMAL">Normal</option>
                      <option [ngValue]="PlanType.VARIABLE">Variable</option>
                      <option [ngValue]="PlanType.ON_DEMAND">On Demand</option>
                    </select>
                    <i class="arrow"></i>
                    @if (form.controls['type'].hasError('required') && form.controls['type'].touched) {
                      <small class="form-error-msg"> Tipo de plan es requerido </small>
                    }
                  </div>
                  <div class="items">
                    <div><label for="name">Nombre del plan*</label> <i class="material-icons icon-help" matTooltip="Se refiere al plan de suscripción dentro de tu portal, ej. “plan mensual” o “plan VIP”">help_outline</i> </div>
                    <input [formControl]="form.controls['name_plan']" tabindex="2"  required type="text" placeholder="Ej: Club de suscripción">
                    @if (form.controls['name_plan'].hasError('required') && form.controls['name_plan'].touched) {
                      <small
                      class="form-error-msg"> Nombre es requerido </small>
                    }
                  </div>
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>  <label for="cost">Costo*</label><i class="material-icons icon-help" matTooltip="Se refiere a lo que quieres cobrar por tu plan según la frecuencia, Ej. $20 al mes.">help_outline</i></div>
                      <input [formControl]="form.controls['feeCost_plan']" tabindex="3" type="number" required placeholder="Ej: $99">
                      @if (form.controls['feeCost_plan'].hasError('required') && form.controls['feeCost_plan'].touched) {
                        <small
                        class="form-error-msg"> Costo es requerido </small>
                      }
                    </div>
                  }
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <label for="cost-per-subscription">Costo por inscripción</label>
                      <input type="text" placeholder="Ej: $199">
                    </div>
                  }
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div> <label for="cost-per-freeze">Costo por congelamiento*</label><i class="material-icons icon-help" matTooltip="Se refiere a cuánto le cuesta al cliente final “congelar su plan” qué significa detener el plan de forma indefinida sin desafiliarse.  Usualmente se aplica cuando el cliente está de viaje, para no perderlo.">help_outline</i>
                    </div>  <input  [formControl]="form.controls['freezeCostPlan']" tabindex="6" type="number" required placeholder="Ej: $25">
                    @if (form.controls['freezeCostPlan'].hasError('required') && form.controls['freezeCostPlan'].touched) {
                      <small
                      class="form-error-msg"> Costo por Congelamiento es requerido </small>
                    }
                  </div>
                }

              </div>
              <div class="right">
                @if (!isVariable && !isOnDemand) {
                  <div class="items">
                    <div> <label for="tax">Impuesto*</label> <i class="material-icons icon-help" matTooltip="Se refiere al impuesto según tu tipo de producto. Ej. Comida 0%, alcohol 10%, servicios 7%, etc.">help_outline</i>
                  </div><input [formControl]="form.controls['taxRate_plan']" tabindex="4" type="number" placeholder="Ej: 5%">
                  @if (form.controls['taxRate_plan'].hasError('required') && form.controls['taxRate_plan'].touched) {
                    <small
                    class="form-error-msg"> Impuesto es requerido </small>
                  }
                </div>
              }
              <div class="items">
                <div> <label for="frequency">Frecuencia*</label><i class="material-icons icon-help" matTooltip=" Se refiere a la recurrencia de tu plan “mensual, quincenal, bimestral, etc”.">help_outline</i>
              </div><select [formControl]="form.controls['frecuency']" tabindex="5" required (change)="onChangeFrecuency($event.target.selectedIndex)">
              <option  disabled="" selected="" value="">Seleccione una opcion</option>
              @for (f of frecuencies; track f) {
                <option  [value]="f.id" > {{ f.name_frecuency | dynamicTranslate }} </option>
              }
            </select>
            <i class="arrow"></i>
            @if (form.controls['frecuency'].hasError('required') && form.controls['frecuency'].touched) {
              <small
              class="form-error-msg"> Frecuencia es requerido </small>
            }
          </div>
          @if (!isOnDemand) {
            <div class="items">
              <div>
                <label for="qty_installments_to_collect_plan">Cantidad de Cuotas a cobrar</label>
                <i class="material-icons icon-help" matTooltip="Se refiere a la cantidad de cuotas que se cobrará en el plan.">help_outline</i>
              </div>
              <select [formControl]="form.controls['qty_installments_to_collect_plan']" tabindex="7">
                <option value="" disabled >Seleccione una opción</option>
                <option value="" selected >{{ 'plans.form.noApply' | translate }}</option>
                <option [ngValue]="1">1 Cuota</option>
                @for (i of [].constructor(47); track i; let index = $index) {
                  <option [ngValue]="index + 2">{{ index + 2 }} Cuotas</option>
                }
              </select>
              <i class="arrow"></i>
            </div>
          }
          @if (!isVariable && !isOnDemand) {
            <div class="items">
              <div>
                <label for="is_visible_plan">Se debe visualizar en el portal*</label>
                <i class="material-icons icon-help" matTooltip="Se refiere a si el plan es visible o no.">help_outline</i>
              </div>
              <select [formControl]="form.controls['is_visible_plan']" tabindex="8" required>
                <option value="" disabled selected>Seleccione una opción</option>
                <option [value]="true">Sí</option>
                <option [value]="false">No</option>
              </select>
              <i class="arrow"></i>
              @if (form.controls['is_visible_plan'].hasError('required') && form.controls['is_visible_plan'].touched) {
                <small class="form-error-msg"> Visibilidad es requerido </small>
              }
            </div>
          }

        </div>
      </div>
      <div class="shared-part">
        <div class="items">
          <label for="description">Descripción del plan*</label>
          <textarea [formControl]="form.controls['description']" tabindex="10" rows="3" type="text" placeholder="Ej: Reciba su caja de suscripción"></textarea>
          @if (form.controls['description'].hasError('required') && form.controls['description'].touched) {
            <small
              class="form-error-msg"> Descripción es requerido
            </small>
          }
        </div>
      </div>
      @if (!isVariable && !isOnDemand) {
        <div class="bottom">
          <div class="left">
            <div class="items">
              <label for="image">Imagen de tu plan (tamaño max 720px y 400px)</label>
              <div class="upload-photo">
                <div class="first-part">
                  <input tabindex="9" #inputFile class="form-control" type="file" id="formFile" accept="image/png, image/jpeg, image/svg"  (change)="onLogoChange($event)" >
                  <!-- <img class="up" src="../../../assets/icons/subir.png" alt="subir foto"> <p>Subir archivo</p> -->
                </div>
                <!-- <div>
                <img  src="../../../assets/icons/subir.png" alt="subir foto"> <p>Subir archivo</p>
              </div> -->
              <!-- <img src="../../../assets/icons/photo.png" alt="foto"> -->
            </div>
          </div>
        </div>
        <!-- <div class="right">
        <div class="items">
          <label for="plan">Este plan incluye:</label>
          <input tabindex="8" type="text" placeholder="Listado de beneficios">
        </div>
      </div> -->
    </div>
  }
</div>
</div>
<div class="preview-text2">
  <img src="../../../assets/icons/ver.png" alt="vista previa">
  <p>Vista previa</p>
</div>
<div class="preview">
  <h1>{{ form.controls['name_plan'].value || 'Primer plan' }}</h1>
  <div class="see-photo">
    <img [src]="image64 || '../../../assets/icons/photo.png'" alt="foto">
  </div>
  <h3>Beneficio principal</h3>
  <h1 class="big-number">${{ form.controls['feeCost_plan'].value || '0' }}</h1>
  <h3>{{ frecuencyName  || 'Mensuales' }}</h3>
  <div class="including">
    <ul class="dotted-list">
      <li>{{ form.controls['description'].value}}</li>
    </ul>
  </div>
  <button>Seleccionar</button>
</div>
</div>
<div class="save">
  <button tabindex="11" [disabled]="isSubmitting" (click)="send()" >{{ 'common.save' | translate }}</button>
</div>
</div>
</form>
<div class="options-buttons">
  <button class="back-btn" (click)="goBack()" >Atrás</button>
  <!-- <button class="continue-btn" [disabled]="!showPaymentButton" (click)="processPayment()" >Finalizar portal</button> -->
  <button class="continue-btn"  (click)="goToPortals()" >Mis suscripciones</button>
  <!-- <button class="save2">Guardar</button>
  <button class="delete">Eliminar</button>
  <button class="post" >Publicar</button> -->
</div>
</div>
</body>